// extracted by mini-css-extract-plugin
export default {"form":"MonitorPrompt_form__R-uRD","actions":"MonitorPrompt_actions__KX5Ph","actions1":"MonitorPrompt_actions1__7Ajzp"};